const BASE_URL = process.env.REACT_APP_BACKEND_URL;

const configVariables = {
  BASE_URL,
};

export default {
  ...configVariables,
};
